// import React, { useEffect, useState } from "react";
// import classes from "../css/LoginPage.module.css";
// import { InputText } from "primereact/inputtext";
// import axios from "axios";
// import { baseUrl, loginApi } from "../api/api";
// import { toast } from "react-toastify";
// import { useDispatch, useSelector } from "react-redux";
// import Loader from "../components/Loader";
// import { Link, useLocation, useNavigate } from "react-router-dom";
// import Layout from "../components/Layout";
// import Drawer from "../components/Drawer";
// import Lottie from "lottie-react";
// import footballAnimation from "../animations/logo.json";
// import { setUser } from "../slices/userSlice";
// import { v4 as uuidv4 } from 'uuid';
// import { getHeadersApi, subscribe_api } from "../api/IntegrationAPi";


// const LoginPage = () => {
//   const [number,setNumber] = useState('278732754483');
//   const [userAgent,setUserAgent] = useState(null)

//   const [subLoading, setSubLoading] = useState(false);
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const { lang } = useSelector((state) => state.langSlice);
// const [ip,setIP] = useState(null);
//   const location = useLocation();
//     const [token,setToken] = useState(null)
//       const [loading,setLoading] = useState(false)



//    const params = new URLSearchParams(window.location.search)
//   const ext_ref = params.get('ext_ref') || uuidv4();

//   useEffect(() => {
//   const user_agent = navigator.userAgent;
//   console.log("User-Agent:", user_agent);
//   setUserAgent(user_agent);
// }, []);


//     useEffect(() => {
//     const fetchIP = async () => {
//       try {
//         const res = await axios.get('https://api.ipify.org?format=json');
//         setIP(res.data.ip);
//       } catch (err) {
//         console.log('Error fetching IP:', err);
//       }
//     };

//     fetchIP();
//   }, []);


//     const getHeadersToken=async()=>{

//     console.log('headers-------------------')
    
//     try{
//       const response = await axios.post(getHeadersApi)
//       console.log(response)
//       setToken(response.data)
//     }
//     catch(err){
//       console.log(err)
//       console.log(err.response.data.err.header.customerMessage)
//     }
//   }



 


//   console.log(token)

//   useEffect(()=>{
//     getHeadersToken()
//   },[])




//      const getHeaders=async()=>{
//     // setLoading(true)
//     console.log('getHeaders-------------------')
//     try{
//       setLoading(true)

//       console.log(token);

//       if(!token){
//         //  token = await getToken();
//         console.log('no token present')
//         return;
//       }
      
//       // console.log(token);

//       const xhr = new XMLHttpRequest();
//       const url = 'https://identity.safaricom.com/partner/api/v2/fetchMaskedMsisdn';
    
//       xhr.open('GET', url, true);
//       xhr.setRequestHeader('Content-Type', 'application/json');
//       xhr.setRequestHeader('Authorization', `Bearer ${token}`);
//       xhr.setRequestHeader('X-App', 'he-partner');
//       xhr.setRequestHeader('X-Source-System', 'he-partner');
//       xhr.setRequestHeader('X-MessageID', '1234');

//       console.log(xhr,'xhr--------')

      
      
//       xhr.onreadystatechange = function () {
//         if (xhr.readyState === 4) {
//           if (xhr.status === 200) {
//             try {
//               const response = JSON.parse(xhr.responseText);
//               console.log(response, 'response...');
              
//               // Extract the Msisdn value safely
//               const msisdn = response?.ServiceResponse?.ResponseBody?.Response?.Msisdn ?? null;
              
//               if (msisdn) {
//                 // Auto sign-in user
//                 console.log(msisdn)
//                 setNumber(msisdn)
//                 setLoading(false)
                
//               } else {
//                 // setLoading(false);
                
//               }
//             } catch (error) {
//               console.error('Error parsing response:', error);
//               // setLoading(false);
             
//             }
//           } else {
//             console.error('Request failed with status:', xhr.status);
//             // setLoading(false);
//           }
//         }
//       };
    
//       xhr.send();

//       // console.log(res)


//     }
//     catch(err){
//       console.log(err);
//       // setLoading(false)
//     }
//     // setLoading(false)
//   }





//    useEffect(()=>{
//     getHeaders()
//   },[token])



//     const submitHandler=async(e)=>{
//     console.log(number,'number')
//     e.preventDefault();

//     setSubLoading(true)
//     const data={
//       ani:number,
//       ext_ref:'req_1234324',
//       ip_address:ip,
//       user_agent:userAgent
//     }
   
//     if(number){
//       try{
//         // console.log('number-----------',(number))
//         const res = await axios.post(subscribe_api,data)
//         console.log(res?.data)

//         if(! res?.data.result.cg_url){
//           setSubLoading(false)
//           toast.error(res?.data?.message)
//         }

//         window.location.href = res.data.result.cg_url;

        

//         setTimeout(()=>{
//           setSubLoading(false)
//         },5000)
     
//     }
//     catch(err){
//       console.log(number)
//       setTimeout(()=>{
//         setSubLoading(false)
//       },5000)
//     }
//     }
//   }


//   console.log(!number)

 

//   return (
//     <>
//       {/* <Drawer active={7} /> */}

//       <div className={classes.container}>
//         <div className={classes.sub_container}>
//           <div className={classes.image_main_container}>
//             <div className={classes.image_container}>
//               {/* <img
//                 src="/assets/images/loginImage.png"
//                 alt="login"
//                 className={classes.login_image}
//               /> */}
//               <Lottie
//                 animationData={footballAnimation}
//                 loop={true}
//                 autoPlay={true}
//               />
//             </div>
//           </div>

//           <div className={classes.login_form}>
//             <div className={classes.login_text}>
//               <h2 className={classes.title}>Kickwinn</h2>
//             </div>
//             <div className={classes.desc}>
//               From Standings to Kick-offs - All in KickWin.
//               <br/>
//               <p className={classes.price}>Price 15KSH/Daily</p>
//             </div>
//             <form className={classes.form} onSubmit={submitHandler}>
//               <button type="submit" className={!number ? classes.login_btn_inactive : classes.login_btn} disabled={!number} >
//                 {lang == "english"
//                   ? "Login"
//                   : lang == "spanish"
//                   ? "Acceso"
//                   : lang == "french"
//                   ? "Se connecter"
//                   : lang == "arabic"
//                   ? "تسجيل الدخول"
//                   : "Login"}
//               </button>
//               {!number &&
//               <div className={classes.link}>
//                 ** Switch To Safaricom Network To Subscribe **
//               </div>
//               }
//             </form>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default LoginPage;



// import React from "react";
// import classes from "../css/LoginPage.module.css";
// import { useSelector } from "react-redux";
// import Lottie from "lottie-react";
// import footballAnimation from "../animations/logo.json";

// const LoginPage = () => {
//   const { lang } = useSelector((state) => state.langSlice);

//   const submitHandler = (e) => {
//     e.preventDefault();

//     window.location.replace(
//       "https://dsdp-cg.safaricom.com/consent-gateway/001023838175"
//     );
//   };

//   return (
//     <div className={classes.container}>
//       <div className={classes.sub_container}>
//         <div className={classes.image_main_container}>
//           <div className={classes.image_container}>
//             <Lottie
//               animationData={footballAnimation}
//               loop={true}
//               autoPlay={true}
//             />
//           </div>
//         </div>

//         <div className={classes.login_form}>
//           <div className={classes.login_text}>
//             <h2 className={classes.title}>Kickwinn</h2>
//           </div>

//           <div className={classes.desc}>
//             From Standings to Kick-offs - All in KickWin.
//             <br />
//             <p className={classes.price}>Price 15KSH/Daily</p>
//           </div>

//           <form className={classes.form} onSubmit={submitHandler}>
//             <button type="submit" className={classes.login_btn}>
//               {lang === "english"
//                 ? "Subscribe"
//                 : lang === "spanish"
//                 ? "Suscribirse"
//                 : lang === "french"
//                 ? "S'abonner"
//                 : lang === "arabic"
//                 ? "اشتراك"
//                 : "Subscribe"}
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;



import React, { useState } from "react";
import classes from "../css/LoginPage.module.css";
import { useSelector } from "react-redux";
import Lottie from "lottie-react";
import footballAnimation from "../animations/logo.json";

const LoginPage = () => {
  const { lang } = useSelector((state) => state.langSlice);
  const [loading, setLoading] = useState(false);

  const submitHandler = (e) => {
    e.preventDefault();

    setLoading(true);

    window.location.replace(
      "https://dsdp-cg.safaricom.com/consent-gateway/001023838175"
    );
  };

  return (
    <div className={classes.container}>
      <div className={classes.sub_container}>
        <div className={classes.image_main_container}>
          <div className={classes.image_container}>
            <Lottie
              animationData={footballAnimation}
              loop={true}
              autoPlay={true}
            />
          </div>
        </div>

        <div className={classes.login_form}>
          <div className={classes.login_text}>
            <h2 className={classes.title}>Kickwinn</h2>
          </div>

          <div className={classes.desc}>
            From Standings to Kick-offs - All in KickWin.
            <br />
            <p className={classes.price}>Price 15KSH/Daily</p>
          </div>

          <form className={classes.form} onSubmit={submitHandler}>
            <button
              type="submit"
              className={classes.login_btn}
              disabled={loading}
            >
              {loading ? (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                  }}
                >
                  <span
                    style={{
                      width: "16px",
                      height: "16px",
                      border: "2px solid rgba(255,255,255,0.3)",
                      borderTop: "2px solid white",
                      borderRadius: "50%",
                      display: "inline-block",
                      animation: "spin 1s linear infinite",
                    }}
                  />
                  Redirecting...
                </div>
              ) : (
                lang === "english"
                  ? "Subscribe"
                  : lang === "spanish"
                  ? "Suscribirse"
                  : lang === "french"
                  ? "S'abonner"
                  : lang === "arabic"
                  ? "اشتراك"
                  : "Subscribe"
              )}
            </button>
          </form>
        </div>
      </div>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default LoginPage;